import styled, { css } from 'styled-components';
import { ContentWrapper, FlexColumn } from '../../styled/common';
import { Breakpoints, FontWeight } from '../../styled/constants';
import { StyledSearchContainer } from '../ui/Input/styled';
import { animation } from '../../styled/placeholders.styled';

export const ListWrapper = styled(ContentWrapper)`
  flex-direction: column;

  h1 {
    font-size: 16px;
    font-weight: ${FontWeight.medium};
  }

  #business_items_page_header {
    @media screen and (min-width: ${Breakpoints.tablet}px) {
      display: none;
    }
  }

  @media screen and (min-width: 1439px) {
    min-width: ${Breakpoints.desktop}px;
  }

  .fallback-view {
    margin: auto;
  }
`;

export const SearchContainer = styled(FlexColumn)<{
  $isResidencePage: boolean;
}>`
  align-items: flex-start;
  gap: 20px;
  padding: 15px;

  > .search-container,
  input {
    height: 50px;
    background-color: inherit;
    width: 100%;

    &:focus {
      font-size: 16px;
    }
  }

  .search-container:has(input:focus) {
    border-color: ${({ theme }) => theme.colors.systemColors.blue};
  }

  h1 {
    font-size: 16px;
    font-weight: ${FontWeight.bold};

    @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
      display: none;
    }
  }

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    margin: 5px 0 30px;
    padding: 0;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    flex-direction: row;
    align-items: center;
    gap: ${({ $isResidencePage }) => ($isResidencePage ? '40px' : '70px')};

    ${({ $isResidencePage }) =>
      !$isResidencePage &&
      css`
        > div,
        input {
          max-width: 480px;
        }
      `};

    ${({ $isResidencePage }) =>
      $isResidencePage &&
      css`
        justify-content: space-between;

        ${StyledSearchContainer},
        input {
          max-width: 340px;
        }
      `};
  }
`;

export const SearchPlaceholder = styled.div`
  ${animation};
  height: 50px;
  width: 100%;
  border-radius: 14px;

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    max-width: 340px;
  }
`;

export const SpinnerWrapper = styled.div`
  margin: 150px auto;
  width: 100%;
`;

export const Spinner = styled.span`
  display: block;
  margin: 0 auto;
  width: 30px;
  height: 30px;
  animation: rotation 2s infinite linear;
  background-image: url('/static/images/icon-spinner.svg');
`;

export const fallbackStyles = css`
  padding: 20px 0 15vh;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 10vh 15px 15vh;

    img {
      width: 317px;
      height: 230px;
    }
  }
`;
